import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { getAppNavigationContextDescriptor } from '@core/models/app-navigation.model';

import {
  type ChatConversationExternalAction,
  type ChatEntityLinkAdapter,
  type ChatEntityReference,
} from 'ias-ppr-mt-chat-client';

@Injectable()
export class AscupChatEntityLinkAdapter implements ChatEntityLinkAdapter {
  private readonly router = inject(Router);
  private readonly eventsRoute =
    getAppNavigationContextDescriptor('events').route;

  public getNavigationHref(target: ChatEntityReference): string | null {
    const eventType = this.getEventType(target.type);
    if (!eventType) {
      return null;
    }

    return this.router.serializeUrl(
      this.router.createUrlTree([this.eventsRoute, target.id], {
        queryParams: { eventType },
      }),
    );
  }

  public getResourceUrl(_target: ChatEntityReference): string | null {
    return null;
  }

  public executeAction(action: ChatConversationExternalAction): boolean {
    if (action.semantic !== 'navigate') {
      return false;
    }

    const href = this.getNavigationHref(action.payload);
    if (!href) {
      return false;
    }

    void this.router.navigateByUrl(href);
    return true;
  }

  private getEventType(type: string): 'NNR' | 'SB' | null {
    switch (type) {
      case 'ias-ppr:NNR':
        return 'NNR';
      case 'ias-ppr:SB':
        return 'SB';
      default:
        return null;
    }
  }
}
